/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
export default function navigation() {
	const mobile = () => {
		const siteNavigation = document.querySelector(
			'section.header-mobile-menu'
		);
		const button = document.querySelector('ul.header-mobile__hamburger');
		//Check if the hamburger and mobile menu are found
		if (
			siteNavigation instanceof window.HTMLElement &&
			button instanceof window.HTMLElement
		) {
			// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
			button.addEventListener('click', function () {
				siteNavigation.classList.toggle('header-mobile-menu--toggled');
				if (button.getAttribute('aria-expanded') === 'true') {
					button.setAttribute('aria-expanded', 'false');
				} else {
					button.setAttribute('aria-expanded', 'true');
				}
			});
		}

		const toggleBtns = document.querySelectorAll('.toggle-button');
		toggleBtns.forEach(btn => {
			btn.addEventListener('click', function() {
				if(this.nextElementSibling) {
					this.nextElementSibling.classList.toggle('active')
					this.classList.toggle('active')
				}
			})
		});
	};
	mobile();

	const search = () => {
		const $icon = document.querySelector('svg.header-mobile__search-icon');
		const $dropdown = document.querySelector(
			'section.search-form-dropdown'
		);
		if (
			$icon instanceof SVGElement &&
			$dropdown instanceof window.HTMLElement
		) {
			$icon.addEventListener('click', function () {
				$dropdown.classList.toggle('search-form-dropdown--toggled');
			});
		}
	};
	search();

	const scrollBackToTop = () => {
		const $icon = document.querySelector('nav.back-to-top');
		if ($icon instanceof window.HTMLElement) {
			$icon.addEventListener('click', function () {
				window.scrollTo({ top: 0, behavior: 'smooth' });
			});
		}
	};
	scrollBackToTop();

	const navigationClone = () => {
		const $header = document.querySelector('section.header-desktop');
		if ($header instanceof window.HTMLElement) {
			const $clone = $header.cloneNode(true);
			$clone.classList.add('header-desktop--clone');
			$header.parentNode.insertBefore($clone, $header.nextSibling);
		}
	};
	navigationClone();


	const navigationHover = () => {
		const menuItem = document.querySelectorAll('.menu-top-item')
		const headerMenus = document.querySelectorAll('.menu-main-menu-container')
		const activeClass = 'menu-active'
		
		menuItem.forEach(item => {
			item.addEventListener('mouseenter', function() {
				headerMenus.forEach(element => {
					element.classList.add(activeClass)
				});
			})
			item.addEventListener('mouseleave', function() {
				headerMenus.forEach(element => {
					element.classList.remove(activeClass)
				});
			})
		});
	}
	navigationHover();

	let lastScrollTop = 0;
	const onScrollAddClass = (lastScrollTop) => {
		document.addEventListener('scroll', function() {
			const body = document.querySelector('body');
			const add_class_on_scroll = () => body.classList.add('scrolling');
			const remove_class_on_scroll = () => body.classList.remove('scrolling');
	
			const offset = window.pageYOffset || document.documentElement.scrollTop;
			if (offset > lastScrollTop) {
				if (offset >= 150) {
					add_class_on_scroll();
				} else {
					remove_class_on_scroll();
				}
			} else {
				remove_class_on_scroll();
			}
			lastScrollTop = offset <= 0 ? 0 : offset
		}); 
	};
	onScrollAddClass(lastScrollTop);
}
